import React from "react";

export function TermsScreen(): React.ReactElement {
  const sectionStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  };

  const headingStyle: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: 700,
    color: "var(--color-graphite)",
    margin: "0",
    paddingTop: "6px",
  };

  const paragraphStyle: React.CSSProperties = {
    margin: 0,
    fontSize: "14px",
    lineHeight: "1.6",
    color: "var(--color-graphite)",
  };

  const listStyle: React.CSSProperties = {
    margin: "4px 0 0 0",
    paddingLeft: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    fontSize: "14px",
    lineHeight: "1.6",
    color: "var(--color-graphite)",
  };

  const mailLinkStyle: React.CSSProperties = {
    color: "var(--color-graphite)",
    fontWeight: 600,
    textDecoration: "underline",
  };

  return (
    <div data-testid="terms-screen" style={{ display: "flex", flexDirection: "column", gap: "16px", paddingBottom: "24px" }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "4px 4px",
          minHeight: "44px",
          flexShrink: 0,
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "22px",
            lineHeight: "26px",
            fontWeight: 700,
            color: "var(--color-graphite)",
            letterSpacing: "-0.02em",
          }}
        >
          Условия использования
        </h1>
        <span
          style={{
            fontSize: "12px",
            color: "var(--color-slate)",
            marginTop: "4px",
            fontWeight: 500,
          }}
        >
          Редакция от 28 августа 2026 года
        </span>
      </div>

      {/* Content Card */}
      <div
        style={{
          backgroundColor: "var(--color-paper)",
          borderRadius: "var(--radius-card)",
          boxShadow: "var(--shadow-floating)",
          padding: "20px 18px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {/* Preamble */}
        <p style={{ ...paragraphStyle, color: "var(--color-graphite)" }}>
          Настоящие Условия использования регулируют использование сервиса <strong>Corgi Work</strong> (далее — «Сервис»).
        </p>
        <p style={paragraphStyle}>
          Лицо, управляющее Сервисом, далее именуется <strong>«Администратор»</strong>, а лицо, использующее Сервис, — <strong>«Пользователь»</strong>.
        </p>
        <p style={paragraphStyle}>
          Начиная использовать Telegram-бот Corgi Work, Telegram Mini App, оформляя платный доступ или продолжая использование Сервиса после ознакомления с настоящими Условиями, Пользователь подтверждает, что ознакомился с ними и согласен соблюдать их.
        </p>
        <p style={{ ...paragraphStyle, fontWeight: 500, color: "var(--color-graphite)" }}>
          Если Пользователь не согласен с настоящими Условиями, он должен прекратить использование Сервиса.
        </p>

        {/* 1. О Сервисе */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>1. О Сервисе</h2>
          <p style={paragraphStyle}><strong>1.1.</strong> Corgi Work — информационно-технический сервис для поиска, фильтрации и доставки информации об удалённых вакансиях преимущественно в сфере IT и Digital.</p>
          <p style={paragraphStyle}><strong>1.2.</strong> Сервис получает и обрабатывает сведения о вакансиях из доступных ему внешних источников, включая Telegram-каналы, сайты с вакансиями, карьерные страницы компаний и иные интернет-ресурсы.</p>
          <p style={paragraphStyle}><strong>1.3.</strong> Пользователь может создавать поисковые профили и задавать критерии поиска, включая специализацию, уровень, навыки, опыт, язык, местоположение и другие параметры, доступные в интерфейсе.</p>
          <p style={paragraphStyle}><strong>1.4.</strong> На основании выбранных Пользователем критериев Сервис автоматически определяет потенциально подходящие вакансии и может направлять их Пользователю через Telegram и иными доступными способами.</p>
          <p style={paragraphStyle}><strong>1.5.</strong> Corgi Work не является работодателем, кадровым или рекрутинговым агентством, представителем работодателя либо стороной каких-либо трудовых, гражданско-правовых или иных отношений между Пользователем и работодателем, рекрутером или другим третьим лицом.</p>
          <p style={paragraphStyle}><strong>1.6.</strong> Сервис не принимает решений о найме, не организует трудоустройство и не выступает посредником при заключении трудового договора.</p>
          <p style={paragraphStyle}><strong>1.7.</strong> Основная функция Сервиса заключается исключительно в автоматизированном поиске, обработке, фильтрации и доставке информации.</p>
        </section>

        {/* 2. Источники вакансий */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>2. Источники вакансий</h2>
          <p style={paragraphStyle}><strong>2.1.</strong> Информация о вакансиях поступает преимущественно от третьих лиц и из внешних источников, которые Администратор не контролирует.</p>
          <p style={paragraphStyle}><strong>2.2.</strong> Состав источников может изменяться без предварительного уведомления.</p>
          <p style={paragraphStyle}><strong>2.3.</strong> Администратор вправе в любое время добавлять новые источники, прекращать обработку отдельных источников или временно приостанавливать их мониторинг.</p>
          <p style={paragraphStyle}><strong>2.4.</strong> Указание в Сервисе количества отслеживаемых Telegram-каналов, сайтов или иных источников является информационным и не является гарантией постоянной доступности, бесперебойного мониторинга или обработки каждого из них.</p>
          <p style={paragraphStyle}><strong>2.5.</strong> Доступ Сервиса к некоторым источникам может зависеть от их технической доступности, структуры сайта, API, правил платформы, ограничений доступа и иных обстоятельств, находящихся вне контроля Администратора.</p>
        </section>

        {/* 3. Информация о вакансиях */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>3. Информация о вакансиях</h2>
          <p style={paragraphStyle}><strong>3.1.</strong> Администратор не является автором большинства публикуемых вакансий и не контролирует сведения, размещённые в первоисточниках.</p>
          <p style={paragraphStyle}><strong>3.2.</strong> Администратор не гарантирует:</p>
          <ul style={listStyle}>
            <li>достоверность информации о вакансии;</li>
            <li>полноту описания;</li>
            <li>актуальность вакансии;</li>
            <li>наличие вакансии после её доставки Пользователю;</li>
            <li>достоверность информации о работодателе или рекрутере;</li>
            <li>правильность указанной заработной платы;</li>
            <li>правильность сведений об опыте, навыках, местоположении или формате работы;</li>
            <li>действительность указанных контактных данных;</li>
            <li>получение ответа от работодателя;</li>
            <li>приглашение на собеседование;</li>
            <li>получение предложения о работе;</li>
            <li>трудоустройство;</li>
            <li>получение Пользователем какого-либо дохода или иного результата.</li>
          </ul>
          <p style={paragraphStyle}><strong>3.3.</strong> Если информация в Corgi Work отличается от информации в первоисточнике, Пользователь должен руководствоваться первоисточником.</p>
          <p style={paragraphStyle}><strong>3.4.</strong> Обработка вакансий осуществляется в том числе автоматически. В результате возможны ошибки классификации, извлечения, преобразования и сопоставления информации.</p>
          <p style={paragraphStyle}><strong>3.5.</strong> В частности, Сервис может ошибочно определить:</p>
          <ul style={listStyle}>
            <li>специализацию;</li>
            <li>уровень позиции;</li>
            <li>требуемый опыт;</li>
            <li>технологический стек;</li>
            <li>язык;</li>
            <li>местоположение;</li>
            <li>возможность удалённой работы;</li>
            <li>размер заработной платы;</li>
            <li>иные характеристики вакансии.</li>
          </ul>
          <p style={paragraphStyle}><strong>3.6.</strong> Пользователь обязан самостоятельно проверять существенную информацию перед откликом или принятием любых решений.</p>
        </section>

        {/* 4. Подбор и доставка вакансий */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>4. Подбор и доставка вакансий</h2>
          <p style={paragraphStyle}><strong>4.1.</strong> Сервис стремится доставлять Пользователю вакансии, соответствующие его поисковым профилям, однако не гарантирует абсолютную точность сопоставления.</p>
          <p style={paragraphStyle}><strong>4.2.</strong> Сервис не гарантирует, что:</p>
          <ul style={listStyle}>
            <li>обнаружит каждую существующую вакансию;</li>
            <li>обнаружит вакансию сразу после публикации;</li>
            <li>доставит каждую обнаруженную вакансию;</li>
            <li>доставит вакансию раньше других сервисов;</li>
            <li>не пропустит потенциально подходящую вакансию;</li>
            <li>не отправит вакансию, которая фактически не подходит Пользователю.</li>
          </ul>
          <p style={paragraphStyle}><strong>4.3.</strong> Время между публикацией вакансии в первоисточнике, её обнаружением и доставкой Пользователю может различаться.</p>
          <p style={paragraphStyle}><strong>4.4.</strong> Corgi Work не гарантирует какого-либо минимального количества вакансий за день, неделю, месяц или иной период.</p>
          <p style={paragraphStyle}><strong>4.5.</strong> Количество доставленных вакансий зависит, в частности, от:</p>
          <ul style={listStyle}>
            <li>ситуации на рынке труда;</li>
            <li>выбранной специализации;</li>
            <li>требований Пользователя;</li>
            <li>количества и строгости фильтров;</li>
            <li>активности работодателей;</li>
            <li>доступности внешних источников.</li>
          </ul>
          <p style={paragraphStyle}><strong>4.6.</strong> Отсутствие подходящих вакансий при узко настроенных критериях само по себе не является признаком неисправности Сервиса.</p>
        </section>

        {/* 5. Работодатели, рекрутеры и безопасность */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>5. Работодатели, рекрутеры и безопасность</h2>
          <p style={paragraphStyle}><strong>5.1.</strong> Corgi Work не осуществляет обязательную предварительную проверку каждого работодателя, автора объявления, рекрутера или иного лица, упомянутого в вакансии.</p>
          <p style={paragraphStyle}><strong>5.2.</strong> Появление вакансии в Corgi Work не означает, что Администратор подтверждает надёжность или добросовестность соответствующего работодателя либо рекомендует его Пользователю.</p>
          <p style={paragraphStyle}><strong>5.3.</strong> Пользователь самостоятельно оценивает потенциального работодателя и риски дальнейшего взаимодействия.</p>
          <p style={paragraphStyle}><strong>5.4.</strong> Администратор в максимально допустимой законом степени не несёт ответственности за:</p>
          <ul style={listStyle}>
            <li>мошеннические вакансии;</li>
            <li>фишинговые сайты;</li>
            <li>действия злоумышленников;</li>
            <li>утрату денежных средств;</li>
            <li>передачу Пользователем персональных данных третьим лицам;</li>
            <li>передачу документов;</li>
            <li>установку вредоносного программного обеспечения;</li>
            <li>последствия общения с работодателями или рекрутерами;</li>
            <li>действия либо бездействие третьих лиц.</li>
          </ul>
          <p style={paragraphStyle}><strong>5.5.</strong> Пользователю рекомендуется самостоятельно проверять работодателей и проявлять разумную осторожность при переходе по внешним ссылкам и передаче информации третьим лицам.</p>
        </section>

        {/* 6. Учётная запись и использование Сервиса */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>6. Учётная запись и использование Сервиса</h2>
          <p style={paragraphStyle}><strong>6.1.</strong> Доступ к Сервису осуществляется преимущественно через Telegram.</p>
          <p style={paragraphStyle}><strong>6.2.</strong> Пользователь отвечает за безопасность своего Telegram-аккаунта и за действия, совершённые с его использованием.</p>
          <p style={paragraphStyle}><strong>6.3.</strong> Пользователь не вправе:</p>
          <ul style={listStyle}>
            <li>вмешиваться в работу Сервиса;</li>
            <li>пытаться получить несанкционированный доступ к его инфраструктуре;</li>
            <li>обходить технические или тарифные ограничения;</li>
            <li>проводить автоматизированное массовое извлечение данных из Сервиса без разрешения Администратора;</li>
            <li>перепродавать доступ к Сервису;</li>
            <li>предоставлять платный доступ третьим лицам через свою учётную запись;</li>
            <li>использовать Сервис для незаконной деятельности;</li>
            <li>создавать чрезмерную нагрузку на инфраструктуру;</li>
            <li>использовать несколько аккаунтов с целью неоднократного получения пробного периода;</li>
            <li>пытаться манипулировать платежами, статусами подписки или доступом к функциям.</li>
          </ul>
          <p style={paragraphStyle}><strong>6.4.</strong> При выявлении злоупотреблений, мошенничества, угроз безопасности или существенного нарушения настоящих Условий Администратор вправе временно ограничить или прекратить доступ Пользователя к Сервису.</p>
        </section>

        {/* 7. Пробный период */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>7. Пробный период</h2>
          <p style={paragraphStyle}><strong>7.1.</strong> Пользователю может быть предоставлен бесплатный пробный период продолжительностью 5 календарных дней.</p>
          <p style={paragraphStyle}><strong>7.2.</strong> Условия пробного периода отображаются в интерфейсе Сервиса.</p>
          <p style={paragraphStyle}><strong>7.3.</strong> Если перед началом пробного периода прямо не указано иное, его окончание само по себе не приводит к автоматическому списанию денежных средств.</p>
          <p style={paragraphStyle}><strong>7.4.</strong> После окончания пробного периода функции, требующие платного доступа, могут стать недоступны до оформления платной подписки.</p>
          <p style={paragraphStyle}><strong>7.5.</strong> Пробный период предназначен для ознакомления с Сервисом и, как правило, предоставляется одному Пользователю один раз.</p>
          <p style={paragraphStyle}><strong>7.6.</strong> Администратор вправе отказать в предоставлении дополнительного пробного периода при наличии признаков злоупотребления.</p>
        </section>

        {/* 8. Платная подписка */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>8. Платная подписка</h2>
          <p style={paragraphStyle}><strong>8.1.</strong> Для доступа к отдельным функциям Corgi Work может требоваться платная подписка.</p>
          <p style={paragraphStyle}><strong>8.2.</strong> Перед оформлением подписки Пользователю отображаются её существенные условия, включая стоимость, валюту, период оплаты и доступный функционал.</p>
          <p style={paragraphStyle}><strong>8.3.</strong> Если подписка предусматривает автоматическое продление, информация об этом должна быть показана Пользователю до оплаты.</p>
          <p style={paragraphStyle}><strong>8.4.</strong> Оформляя подписку с автоматическим продлением, Пользователь соглашается на периодическое списание установленной стоимости до момента прекращения автоматического продления.</p>
          <p style={paragraphStyle}><strong>8.5.</strong> Если не указано иное, оплаченная ежемесячная подписка предоставляется на один расчётный месяц и затем автоматически продлевается на последующие периоды.</p>
          <p style={paragraphStyle}><strong>8.6.</strong> Подписка считается активированной после получения Сервисом достоверного подтверждения успешной оплаты.</p>
          <p style={paragraphStyle}><strong>8.7.</strong> Цена подписки для будущих периодов может изменяться.</p>
          <p style={paragraphStyle}><strong>8.8.</strong> Изменение стоимости не применяется задним числом к уже оплаченному периоду.</p>
          <p style={paragraphStyle}><strong>8.9.</strong> Если применимое законодательство требует уведомления Пользователя об изменении цены или получения дополнительного согласия, соответствующие требования соблюдаются до применения новой стоимости.</p>
        </section>

        {/* 9. Обработка платежей */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>9. Обработка платежей</h2>
          <p style={paragraphStyle}><strong>9.1.</strong> Для обработки платежей Corgi Work может использовать сторонних платёжных провайдеров, банки, платёжные системы и другие финансовые сервисы.</p>
          <p style={paragraphStyle}><strong>9.2.</strong> Конкретные доступные способы оплаты могут зависеть от страны, валюты, платёжного средства и используемого платёжного провайдера.</p>
          <p style={paragraphStyle}><strong>9.3.</strong> Перечень платёжных провайдеров может изменяться без внесения изменений в настоящие Условия.</p>
          <p style={paragraphStyle}><strong>9.4.</strong> Платёж может осуществляться непосредственно на стороне стороннего платёжного сервиса.</p>
          <p style={paragraphStyle}><strong>9.5.</strong> Corgi Work не получает и не хранит полные данные банковской карты Пользователя, если такие данные вводятся непосредственно в интерфейсе стороннего платёжного провайдера.</p>
          <p style={paragraphStyle}><strong>9.6.</strong> Использование стороннего платёжного сервиса может дополнительно регулироваться его собственными условиями использования и политикой конфиденциальности.</p>
          <p style={paragraphStyle}><strong>9.7.</strong> Доступность определённого способа оплаты, валюты или платежного инструмента определяется соответствующим провайдером.</p>
          <p style={paragraphStyle}><strong>9.8.</strong> В максимально допустимой законом степени Администратор не несёт ответственности за:</p>
          <ul style={listStyle}>
            <li>отказ банка провести платеж;</li>
            <li>отклонение транзакции;</li>
            <li>технические проблемы платёжной системы;</li>
            <li>проверки со стороны платёжного провайдера;</li>
            <li>временную блокировку операции;</li>
            <li>невозможность использования конкретной карты или валюты;</li>
            <li>задержки обработки или возврата, произошедшие на стороне третьего лица.</li>
          </ul>
        </section>

        {/* 10. Отмена автоматического продления */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>10. Отмена автоматического продления</h2>
          <p style={paragraphStyle}><strong>10.1.</strong> Пользователь может отключить автоматическое продление подписки через предусмотренный для этого интерфейс Corgi Work либо связавшись с поддержкой.</p>
          <p style={paragraphStyle}><strong>10.2.</strong> После отключения автоматического продления доступ к платным функциям сохраняется до окончания уже оплаченного периода, если иное не предусмотрено обязательным законодательством или условиями, явно показанными Пользователю.</p>
          <p style={paragraphStyle}><strong>10.3.</strong> Отключение автоматического продления предотвращает последующие списания, но само по себе не означает возврата оплаты за уже начавшийся период.</p>
        </section>

        {/* 11. Возврат денежных средств и право на отказ */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>11. Возврат денежных средств и право на отказ</h2>
          <p style={paragraphStyle}>
            <strong>11.1.</strong> Запросы по платежам и возвратам можно направлять в службу поддержки:{" "}
            <a href="mailto:corgiwork@proton.me" style={mailLinkStyle}>corgiwork@proton.me</a>
          </p>
          <p style={paragraphStyle}><strong>11.2.</strong> За уже начавшийся оплаченный период возврат средств автоматически не предоставляется, кроме случаев, когда возврат обязателен в соответствии с применимым законодательством или отдельно согласован Администратором.</p>
          <p style={paragraphStyle}><strong>11.3.</strong> Если произошёл подтверждённый двойной платёж либо иной очевидный технический ошибочный платёж, Пользователь вправе обратиться в поддержку для проверки операции.</p>
          <p style={paragraphStyle}><strong>11.4.</strong> Ничто в настоящих Условиях не ограничивает обязательные права потребителя, от которых он не может отказаться по закону.</p>
          <p style={paragraphStyle}><strong>11.5.</strong> Если применимое законодательство предоставляет Пользователю право отказаться от дистанционно заключённого договора в течение установленного периода, такое право сохраняется.</p>
          <p style={paragraphStyle}><strong>11.6.</strong> Если Пользователь прямо просит начать предоставление цифровой услуги до окончания предусмотренного законом периода отказа, последствия последующего отказа, включая возможность удержания пропорциональной стоимости уже оказанной услуги, определяются применимым законодательством.</p>
        </section>

        {/* 12. Доступность Сервиса */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>12. Доступность Сервиса</h2>
          <p style={paragraphStyle}><strong>12.1.</strong> Сервис предоставляется по принципу «как есть» (as is) и «по мере доступности» (as available).</p>
          <p style={paragraphStyle}><strong>12.2.</strong> Администратор не гарантирует:</p>
          <ul style={listStyle}>
            <li>непрерывную работу Сервиса;</li>
            <li>отсутствие ошибок;</li>
            <li>отсутствие временных простоев;</li>
            <li>сохранение всех функций в неизменном виде;</li>
            <li>конкретную скорость работы;</li>
            <li>конкретную частоту обновления;</li>
            <li>постоянную доступность каждого внешнего источника.</li>
          </ul>
          <p style={paragraphStyle}><strong>12.3.</strong> Работа Corgi Work зависит от сторонней инфраструктуры, включая Telegram, интернет-инфраструктуру, хостинг, базы данных, платёжные сервисы и сайты-источники.</p>
          <p style={paragraphStyle}><strong>12.4.</strong> Сбой или изменение стороннего сервиса может повлиять на отдельные функции Corgi Work.</p>
          <p style={paragraphStyle}><strong>12.5.</strong> Администратор вправе временно ограничить доступ к Сервису для:</p>
          <ul style={listStyle}>
            <li>технического обслуживания;</li>
            <li>обновления;</li>
            <li>исправления ошибок;</li>
            <li>обеспечения безопасности;</li>
            <li>миграции инфраструктуры.</li>
          </ul>
        </section>

        {/* 13. Изменение Сервиса */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>13. Изменение Сервиса</h2>
          <p style={paragraphStyle}><strong>13.1.</strong> Corgi Work является развивающимся программным продуктом.</p>
          <p style={paragraphStyle}><strong>13.2.</strong> Администратор вправе изменять:</p>
          <ul style={listStyle}>
            <li>интерфейс;</li>
            <li>алгоритмы подбора;</li>
            <li>структуру поисковых профилей;</li>
            <li>количество доступных профилей;</li>
            <li>набор фильтров;</li>
            <li>состав источников;</li>
            <li>частоту мониторинга;</li>
            <li>способы доставки;</li>
            <li>используемые технологии;</li>
            <li>внешние интеграции.</li>
          </ul>
          <p style={paragraphStyle}><strong>13.3.</strong> Отдельные функции могут быть добавлены, изменены или прекращены.</p>
          <p style={paragraphStyle}><strong>13.4.</strong> Если изменение существенно затрагивает уже оплаченный доступ Пользователя, к нему применяются ограничения и гарантии, установленные обязательным законодательством.</p>
        </section>

        {/* 14. Сторонние сайты и сервисы */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>14. Сторонние сайты и сервисы</h2>
          <p style={paragraphStyle}><strong>14.1.</strong> Corgi Work может содержать ссылки на:</p>
          <ul style={listStyle}>
            <li>сайты работодателей;</li>
            <li>сайты с вакансиями;</li>
            <li>Telegram-каналы;</li>
            <li>профили рекрутеров;</li>
            <li>социальные сети;</li>
            <li>иные сторонние ресурсы.</li>
          </ul>
          <p style={paragraphStyle}><strong>14.2.</strong> Администратор не управляет такими ресурсами и не контролирует их содержание.</p>
          <p style={paragraphStyle}><strong>14.3.</strong> Наличие ссылки не означает одобрения соответствующего ресурса, лица или организации.</p>
          <p style={paragraphStyle}><strong>14.4.</strong> Переход на сторонний ресурс осуществляется Пользователем самостоятельно.</p>
          <p style={paragraphStyle}><strong>14.5.</strong> Администратор не несёт ответственности за содержимое, доступность, безопасность или политику обработки данных сторонних ресурсов.</p>
        </section>

        {/* 15. Интеллектуальная собственность */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>15. Интеллектуальная собственность</h2>
          <p style={paragraphStyle}><strong>15.1.</strong> Права на программный код Corgi Work, собственные элементы дизайна, фирменное оформление, графику и иные созданные специально для Сервиса материалы принадлежат Администратору либо используются им на законном основании.</p>
          <p style={paragraphStyle}><strong>15.2.</strong> Наименования компаний, товарные знаки, тексты вакансий, изображения и иные материалы третьих лиц принадлежат соответствующим правообладателям.</p>
          <p style={paragraphStyle}><strong>15.3.</strong> Отображение информации о вакансии в Corgi Work не означает перехода прав на соответствующие материалы к Администратору.</p>
          <p style={paragraphStyle}><strong>15.4.</strong> Информация из внешних источников используется для целей поиска, систематизации, информирования Пользователя и направления его к первоисточнику.</p>
          <p style={paragraphStyle}>
            <strong>15.5.</strong> Правообладатель, полагающий, что определённый материал нарушает его права, может обратиться по адресу:{" "}
            <a href="mailto:corgiwork@proton.me" style={mailLinkStyle}>corgiwork@proton.me</a> с указанием материала и основания обращения.
          </p>
        </section>

        {/* 16. Ограничение ответственности */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>16. Ограничение ответственности</h2>
          <p style={paragraphStyle}><strong>16.1.</strong> В максимально допустимой применимым законодательством степени Администратор не несёт ответственности за:</p>
          <ul style={listStyle}>
            <li>упущенную выгоду;</li>
            <li>потерю потенциального заработка;</li>
            <li>потерю возможности трудоустройства;</li>
            <li>потерю деловой возможности;</li>
            <li>косвенные или последующие убытки;</li>
            <li>решения Пользователя на основании полученных вакансий;</li>
            <li>отсутствие ответа работодателя;</li>
            <li>отказ работодателя;</li>
            <li>содержание вакансий;</li>
            <li>действия работодателей и рекрутеров;</li>
            <li>действия мошенников;</li>
            <li>сторонние сайты;</li>
            <li>удаление или изменение вакансии;</li>
            <li>задержку обнаружения вакансии;</li>
            <li>недоставку отдельной вакансии;</li>
            <li>ошибочный подбор вакансии;</li>
            <li>сбои Telegram;</li>
            <li>сбои сторонних сайтов;</li>
            <li>сбои платёжных сервисов;</li>
            <li>иные обстоятельства, находящиеся вне разумного контроля Администратора.</li>
          </ul>
          <p style={paragraphStyle}><strong>16.2.</strong> Администратор не гарантирует достижение Пользователем конкретного результата от использования Corgi Work.</p>
          <p style={paragraphStyle}><strong>16.3.</strong> Сам факт оплаты подписки не гарантирует Пользователю получение определённого количества вакансий, откликов, собеседований или предложений о работе.</p>
          <p style={paragraphStyle}><strong>16.4.</strong> Если применимое законодательство разрешает ограничение размера ответственности, совокупная ответственность Администратора по требованиям одного Пользователя, непосредственно связанным с использованием Corgi Work, ограничивается стоимостью одного последнего оплаченного месяца подписки этого Пользователя.</p>
          <p style={paragraphStyle}><strong>16.5.</strong> Ограничения настоящего раздела действуют только в той степени, в которой они допускаются применимым законодательством.</p>
        </section>

        {/* 17. Обстоятельства вне контроля Администратора */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>17. Обстоятельства вне контроля Администратора</h2>
          <p style={paragraphStyle}><strong>17.1.</strong> Администратор не несёт ответственности за невозможность или задержку выполнения обязательств вследствие событий, находящихся вне его разумного контроля.</p>
          <p style={paragraphStyle}><strong>17.2.</strong> К таким обстоятельствам могут относиться, в частности:</p>
          <ul style={listStyle}>
            <li>масштабные технические сбои;</li>
            <li>проблемы интернет-инфраструктуры;</li>
            <li>прекращение или ограничение работы Telegram;</li>
            <li>прекращение доступа к стороннему источнику;</li>
            <li>изменение API;</li>
            <li>изменение правил сторонних платформ;</li>
            <li>действия органов власти;</li>
            <li>санкционные ограничения;</li>
            <li>ограничения платёжных систем;</li>
            <li>кибератаки;</li>
            <li>стихийные бедствия;</li>
            <li>военные действия;</li>
            <li>иные чрезвычайные обстоятельства.</li>
          </ul>
        </section>

        {/* 18. Ограничение или прекращение доступа */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>18. Ограничение или прекращение доступа</h2>
          <p style={paragraphStyle}><strong>18.1.</strong> Пользователь может прекратить использование Сервиса в любое время.</p>
          <p style={paragraphStyle}><strong>18.2.</strong> Администратор вправе ограничить доступ Пользователя при существенном нарушении настоящих Условий, попытке мошенничества, злоупотреблении пробным периодом либо создании угрозы для Сервиса или других пользователей.</p>
          <p style={paragraphStyle}><strong>18.3.</strong> Администратор также вправе прекратить работу Corgi Work полностью или частично.</p>
          <p style={paragraphStyle}><strong>18.4.</strong> Если окончательное прекращение работы Сервиса затрагивает уже оплаченный период Пользователя, соответствующие последствия определяются применимым законодательством.</p>
        </section>

        {/* 19. Персональные данные */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>19. Персональные данные</h2>
          <p style={paragraphStyle}><strong>19.1.</strong> Обработка персональных данных регулируется отдельной Политикой конфиденциальности Corgi Work.</p>
          <p style={paragraphStyle}><strong>19.2.</strong> Для работы Сервиса могут обрабатываться данные, полученные через Telegram, параметры поисковых профилей, информация об использовании Сервиса, сведения о статусе подписки и иная необходимая техническая информация.</p>
          <p style={paragraphStyle}><strong>19.3.</strong> Для работы отдельных функций данные могут передаваться категориям сторонних получателей, включая:</p>
          <ul style={listStyle}>
            <li>поставщиков хостинговых и облачных услуг;</li>
            <li>поставщиков платёжных и финансовых услуг;</li>
            <li>поставщиков технической инфраструктуры;</li>
            <li>сервисы обеспечения безопасности и предотвращения мошенничества;</li>
          </ul>
          <p style={{ ...paragraphStyle, fontStyle: "italic" }}>в объёме, необходимом для соответствующей цели.</p>
        </section>

        {/* 20. Изменение настоящих Условий */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>20. Изменение настоящих Условий</h2>
          <p style={paragraphStyle}><strong>20.1.</strong> Настоящие Условия могут периодически обновляться.</p>
          <p style={paragraphStyle}><strong>20.2.</strong> Актуальная редакция размещается внутри Corgi Work либо по доступной из Сервиса ссылке.</p>
          <p style={paragraphStyle}><strong>20.3.</strong> Существенные изменения могут дополнительно сообщаться Пользователю через Telegram, Mini App или другим доступным способом.</p>
          <p style={paragraphStyle}><strong>20.4.</strong> Продолжение использования Сервиса после вступления изменений в силу означает принятие новой редакции в той степени, в которой такая форма согласия допускается применимым законодательством.</p>
          <p style={paragraphStyle}><strong>20.5.</strong> Изменение Условий не лишает Пользователя обязательных прав, возникших в отношении уже оплаченного периода.</p>
        </section>

        {/* 21. Применимое законодательство и споры */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>21. Применимое законодательство и споры</h2>
          <p style={paragraphStyle}><strong>21.1.</strong> К отношениям между Администратором и Пользователем применяется законодательство, определяемое в соответствии с обязательными нормами и правилами международной подсудности.</p>
          <p style={paragraphStyle}><strong>21.2.</strong> Настоящие Условия не лишают Пользователя обязательной защиты, предоставляемой законодательством и не подлежащей исключению соглашением сторон.</p>
          <p style={paragraphStyle}><strong>21.3.</strong> Перед обращением с претензией Пользователю предлагается связаться со службой поддержки для попытки урегулировать вопрос.</p>
          <p style={paragraphStyle}><strong>21.4.</strong> Споры рассматриваются компетентным судом или иным компетентным органом в соответствии с применимыми правилами.</p>
        </section>

        {/* 22. Поддержка и контакт */}
        <section style={sectionStyle}>
          <h2 style={headingStyle}>22. Поддержка и контакт</h2>
          <p style={paragraphStyle}>
            По вопросам работы Corgi Work, платежей, безопасности, обработки обращений правообладателей и иным вопросам можно связаться со службой поддержки:{" "}
            <a href="mailto:corgiwork@proton.me" style={mailLinkStyle}>corgiwork@proton.me</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsScreen;
